import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class SupportIndex extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			servers: [],
		};
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		const x = await postApi('/v3/support/index', params);
		console.log(x.data);
		this.setState({status: true, servers: x.data.servers?x.data.servers:[]});
		//console.log(x.data);

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		console.log(x.data);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	

	render() {

		const servers = this.state.servers.map((e,i) => {
			let trafficin = Math.floor((e.inbytes / e.download*100));
			let trafficout = Math.floor((e.outbytes / e.upload*100));
			let memory = Math.floor((e.memused / e.memtotal*100));
			let hdd = Math.floor((e.hddused / e.hddsize*100));
			console.log(e.inbytes / e.download*100);
			return (
				<Col xxl={6} xl={12} lg={12} md={6} sm={12} key={i}>
					<div key={i} className="my-1">
						<div className=" font-weight-semibold p-2" style={{orderRadius: 7, border: '1px solid var(--default-border)'}}>
							<Row className="gx-0">

								<Col xs={8} className="text-center">
									<p></p>
									{e.id===1 &&
										<img src="https://cloud.ultrastream.io/images/components/dev.jpg" width="20%" style={{borderRadius: '50%'}} />
									}
									{e.id===2 &&
										<img src="https://mix365.co.uk/images/Logo_Background.png" width="20%" style={{borderRadius: '50%'}} />
									}
									{e.id===3 &&
										<img src="https://rhousemusic.com/images/user.png" width="20%" style={{borderRadius: '50%'}} />
									}
									{e.id>3 &&
										<img src={`https://cloud.ultrastream.io/images/components/server.jpg`} width="20%" style={{borderRadius: '50%'}} />
									}
									<h5>{e.server}</h5>

									{e.id===2 &&
										<a href={`https://${e.subdomain}:4434/admin`} target="_blank" rel="noreferrer">{e.subdomain}</a>
									}
									{e.id===3 &&
										<a href={`https://${e.subdomain}:8443/admin`} target="_blank" rel="noreferrer">{e.subdomain}</a>
									}
									{(e.id === 1 || e.id > 3) &&
										<a href={`https://${e.subdomain}:4433/admin`} target="_blank" rel="noreferrer">{e.subdomain}</a>
									}
									<br />
									{e.location}
									<Row>
										{e.rtmp>0 &&
											<Col className="mt-2">
												Streams: {e.rtmp}<br />
											</Col>
										}
										{e.igpu!==-1&&
											<Col className="mt-2">
												IGPU: {e.igpu}%<br />
											</Col>
										}
									</Row>

								</Col>
								<Col xs={4} className="">
									
									
									<small>Download</small>
									<p className="fs-12 fw-semibold mb-0 text-muted">{e.inbytes} of {e.download} Mpbs<span className="float-end fs-10 fw-normal">{trafficin}%</span></p>
									<div className="progress mb-1 progress-animate" role="progressbar" aria-valuenow={trafficin} aria-valuemin="0" aria-valuemax="100">
										<div className="progress-bar bg-primary" style={{width: `${trafficin}%`}}>
										</div>
									</div>
									<small>Upload</small>
									<p className="fs-12 fw-semibold mb-0 text-muted">{e.outbytes} of {e.upload} Mpbs<span className="float-end fs-10 fw-normal">{trafficout}%</span></p>
									<div className="progress mb-1 progress-animate" role="progressbar" aria-valuenow={trafficout} aria-valuemin="0" aria-valuemax="100">
										<div className="progress-bar bg-primary" style={{width: `${trafficout}%`}}>
										</div>
									</div>
									<small>Memory</small>
									<p className="fs-12 fw-semibold mb-0 text-muted">{e.memused} of {e.memtotal} GB<span className="float-end fs-10 fw-normal">{memory}%</span></p>
									<div className="progress mb-1 progress-animate" role="progressbar" aria-valuenow={memory} aria-valuemin="0" aria-valuemax="100">
										<div className="progress-bar bg-info" style={{width: `${memory}%`}}>
										</div>
									</div>
									<small>Harddrive</small>
									<p className="fs-12 fw-semibold mb-0 text-muted">{e.hddused} of {e.hddsize} GB<span className="float-end fs-10 fw-normal">{hdd}%</span></p>
									<div className="progress mb-1 progress-animate" role="progressbar" aria-valuenow={hdd} aria-valuemin="0" aria-valuemax="100">
										<div className="progress-bar bg-success" style={{width: `${hdd}%`}}>
										</div>
									</div>
								</Col>
							
								<Col xs={4} className="mt-2">
									
								</Col>
								<Col xs={4} className="mt-2">
									
								</Col>
								<Col xs={4} className="mt-2">
									
								</Col>
								
							</Row>
						</div>
					</div>
				</Col>
			)
		});
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card custom-card overflow-hidden">
											<div className="card-header justify-content-between">
												<div className="card-title">Server Analysis</div>
												<div className="dropdown">
													<a aria-label="anchor" href="javascript:void(0);" className="btn btn-outline-light btn-icons btn-sm text-muted" data-bs-toggle="dropdown">
														<i className="fe fe-more-vertical"></i>
													</a>
													<ul className="dropdown-menu">
														<li className="border-bottom"><a className="dropdown-item" href="javascript:void(0);">Action</a></li>
														<li className="border-bottom"><a className="dropdown-item" href="javascript:void(0);">Another action</a></li>
														<li><a className="dropdown-item" href="javascript:void(0);">Something else here</a></li>
													</ul>
												</div>
											</div>
											<div className="card-body">
												<Row>
													{servers}
												</Row>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<div className="card custom-card">
											<div className="card-header">
												<div>
													<h5 className="card-title mb-0">Critical Reports</h5>
												</div>
												<div className="ms-auto">
													<a aria-label="anchor" href="javascript:void(0)" className="btn btn-outline-light btn-icons btn-sm text-muted" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
														<i className="fe fe-more-vertical"></i>
													</a>
													<div className="dropdown-menu dropdown-menu-start">
														<a className="d-flex dropdown-item border-bottom" href="javascript:void(0)">
															<i className="ri-share-forward-line me-2"></i>Share
														</a>
														<a className="d-flex dropdown-item border-bottom" href="javascript:void(0)">
															<i className="ri-download-2-line me-2"></i>Download
														</a>
														<a className="d-flex dropdown-item" href="javascript:void(0)">
															<i className="ri-delete-bin-7-line me-2"></i>Delete
														</a>
													</div>
												</div>
											</div>
											<div className="card-body">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover border table-bordered">
														<thead className="border-top">
															<tr>
																<th scope="row" className="border-bottom-0 text-center">S.NO</th>
																<th scope="row" className="border-bottom-0">Customer Name</th>
																<th scope="row" className="border-bottom-0">Order ID</th>
																<th scope="row" className="border-bottom-0">Order Date</th>
																<th scope="row" className="border-bottom-0">Price</th>
																<th scope="row" className="border-bottom-0">Status</th>
																<th scope="row" className="border-bottom-0">Action</th>
															</tr>
														</thead>
														<tbody>
															<tr className="border-bottom">
																<td className="text-center">01</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/1.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Patty Furniture</a>
																			<p className="text-muted fs-11 mb-0 mt-1">patty@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP90</span></td>
																<td>01 Apr 2022</td>
																<td> $73.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-success-transparent text-success">Delivered</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">02</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/2.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Allie Grate</a>
																			<p className="fs-11 text-muted mb-0 mt-1">allie@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP91</span></td>
																<td>02 Apr 2022</td>
																<td> $73.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-success-transparent text-success">Delivered</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">03</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/3.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Peg Legge</a>
																			<p className="fs-11 text-muted mb-0 mt-1">peg@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP92</span></td>
																<td>24 Mar 2022</td>
																<td> $13.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-danger-transparent text-danger">Cancelled</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">04</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/4.jpg" alt="avatar" />
																		</div>
																	<div className="lh-1">
																		<a href="https://laravelui.spruko.com/velvet/product-details">Maureen Biologist</a>
																		<p className="fs-11 text-muted mb-0 mt-1">maureen@spruko.com</p>
																	</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP93</span></td>
																<td>22 Mar 2022</td>
																<td> $14.600</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-info-transparent text-info">Pending</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">05</td>
																<td>
																	<div className="d-flex align-items-center">
																	<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																		<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/5.jpg" alt="avatar" />
																	</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Olive Yew</a>
																			<p className="text-muted mb-0 mt-1 fs-11">olive@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP94</span></td>
																<td>20 Mar 2022</td>
																<td> $74.965</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-warning-transparent text-warning">Shipped</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>
									
								</Row>
							</div>

							

							{/*
							<Row>
								<Col xl={6}>
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Services
											</div>
										</div>
									</div>
								</Col>

							</Row>
							<div className="row">
								<div className="col-xl-6">
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Default alerts
											</div>
										</div>
										<div className="card-body">
											<div className="alert alert-primary" role="alert">
													A simple primary alert—check it out!
											</div>
											<div className="alert alert-secondary" role="alert">
												A simple secondary alert—check it out!
											</div>
											<div className="alert alert-success" role="alert">
												A simple success alert—check it out!
											</div>
											<div className="alert alert-danger" role="alert">
												A simple danger alert—check it out!
											</div>
											<div className="alert alert-warning" role="alert">
												A simple warning alert—check it out!
											</div>
											<div className="alert alert-info" role="alert">
												A simple info alert—check it out!
											</div>
											<div className="alert alert-light" role="alert">
												A simple light alert—check it out!
											</div>
											<div className="alert alert-dark" role="alert">
												A simple dark alert—check it out!
											</div>
										</div>
									</div>
								</div>
							</div>
							*/}
						</div>
					</div>
				}
			</>
		);
	}
}
